import React from "react";
import { BoxProps, Box, Paper } from "@material-ui/core";

export const CustomPaper: React.FC<BoxProps> = ({ children, ...props }) => (
  <Box clone {...props}>
    <Paper>{children}</Paper>
  </Box>
);
